import { phraseRequestParameters } from 'ErgoBot';
import type { HandStates } from './phraseFingering';

/**
 * What the next-phrase request adds to its query string so selection can serve
 * a phrase the hands can reach: where the previous phrase left each hand, a
 * hand that has not played left out, and the transposition in force, for
 * example `&rhState=66:3:0&lhState=49:5:1&transposition=1`. The states are
 * left out while the previous phrase is not known. Empty when the lesson does
 * not finger its phrases: there is then no transposition to send either.
 */
export const phraseRequestQuery = (
  handStates: HandStates | undefined,
  transposition: number | undefined,
): string =>
  transposition === undefined
    ? ''
    : `&${new URLSearchParams(phraseRequestParameters(handStates ?? {}, transposition)).toString()}`;

/**
 * Whether a served phrase says selection was told where the hands are and held
 * no phrase they can get into (`join_fallback`). Such a phrase is kept: asking
 * again would not find a better one.
 */
export const isJoinFallback = (servedPhrase: { join_fallback?: unknown }): boolean =>
  servedPhrase.join_fallback === true;
